// src/i18n.js
import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';


export function initializeI18n() {
  return new Promise((resolve, reject) => {
    if (i18n.isInitialized) {
      return resolve(i18n);
    }

    if (i18n.isInitializing) {
      const resolveOnce = () => {
        i18n.off('initialized', resolveOnce);
        i18n.off('failedLoading', rejectOnce);
        resolve(i18n);
      };
      const rejectOnce = (lng, ns, error) => {
        i18n.off('initialized', resolveOnce);
        i18n.off('failedLoading', rejectOnce);
        reject(error);
      };
      i18n.on('initialized', resolveOnce);
      i18n.on('failedLoading', rejectOnce);
      return;
    }

    i18n.isInitializing = true;

    i18n
      .use(LanguageDetector)
      .use(HttpApi)
      .use(initReactI18next)
      .init({
        ns: ['common_ns'],
        defaultNS: 'common_ns',
        returnEmptyString: false,
        fallbackLng: false,
        backend: {
          loadPath: (lng, ns) => `/api/localization/portals?lang=${lng}&page=${ns}`,
          requestOptions: {
            timeout: 10000,
            cache: "default",
          },
        },
        reloadInterval: false,

        detection: {
          order: ['htmlTag','localStorage'],
          lookupCookie: 'i18nextLng',
          lookupLocalStorage: 'i18nextLng',
          caches: [],
        },
        load: 'languageOnly',
        lowerCaseLng: true,
      })
      .then(() => {
        i18n.isInitializing = false;
        i18n.isInitialized = true;
        resolve(i18n);
      })
      .catch((error) => {
        i18n.isInitializing = false;
        console.error('Failed to initialize i18n:', error);
        reject(error);
      });
  });
}

export { i18n };
